import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageview } from "@/lib/analytics";

export default function Analytics() {
    const location = useLocation();

    useEffect(() => {
        initAnalytics();
    }, []);

    useEffect(() => {
        trackPageview(location.pathname + location.search, document.title);
    }, [location.pathname, location.search]);

    return null;
}
